import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "brands";

const fetchAllBrands = () => axios.get(baseURL);
const fetchAllBrandsOfBranch = (branchId) => axios.get(baseURL + "/" + branchId);
const addNewBrand = (brand, config) => axios.post(baseURL, brand, config)
const addNewBrandOfBranch = (branchId, brand) => axios.post(baseURL + "/" + branchId, brand)
const deleteBrand = (brandId) => axios.delete(baseURL + "/" + brandId)
export {
    fetchAllBrands,
    fetchAllBrandsOfBranch,
    addNewBrand,
    addNewBrandOfBranch,
    deleteBrand
}
